/** RTK Query / fetch-style errors → user-facing string */
export function extractApiMessage(error) {
  if (error == null) return "Something went wrong.";
  if (typeof error === "string") return error;
  const d = error?.data;
  if (typeof d === "string") return d;
  if (d && typeof d === "object") {
    if (d.message != null && String(d.message).trim()) return String(d.message);
    if (d.error != null && String(d.error).trim()) return String(d.error);
    if (Array.isArray(d.errors)) {
      const parts = d.errors
        .map((x) => (x && (x.msg || x.message)) || "")
        .filter(Boolean);
      if (parts.length) return parts.join(", ");
    }
  }
  if (error?.message != null && String(error.message).trim()) {
    return String(error.message);
  }
  return "Something went wrong.";
}
